export default __webpack_public_path__ + "static/media/collab.9be6688c.png";